module.exports = __webpack_public_path__ + "static/exterior-2-3300bd7cc988a496af41fa8e9be34b31.jpg";